export const calendarTypes = [
  {
    key: "special-events",
    label: "Special Events",
    slug: "",
    views: ["list", "calendar"],
  },
  {
    key: "ice-arena",
    label: "Ice Arena",
    slug: "ice-arena",
    views: ["list", "calendar"],
  },
  {
    key: "open-gym",
    label: "Open Gym",
    slug: "open-gym",
    views: ["list", "calendar"],
  },
];
